import { HeaderText } from "@/components/ui";
import { Tabs, TabsContent, TabsList, TabsTrigger } from "@/components/ui/Tabs";
import { TRACKERS } from "@/constants/Trackers";
import { trackEvent } from "@/lib/tracking";
import { MessagesArchive } from "./MessagesArchive";
import { MessagesInbox } from "./MessagesInbox";

export const Messages = () => {
  return (
    <div className="p-6 h-full overflow-auto pb-12">
      <HeaderText size="xl" className="mb-4">
        Routine Messages
      </HeaderText>

      <section className="mt-4">
        <Tabs defaultValue="inbox">
          <TabsList className="mb-4">
            <TabsTrigger
              onClick={() => {
                trackEvent(TRACKERS.VIEW_INBOX_TAB);
              }}
              value="inbox"
              className="gap-1.5"
            >
              Inbox
            </TabsTrigger>
            <TabsTrigger
              onClick={() => {
                trackEvent(TRACKERS.VIEW_ARCHIVED_TAB);
              }}
              value="archive"
            >
              Archive
            </TabsTrigger>
          </TabsList>
          <TabsContent value="inbox">
            <MessagesInbox />
          </TabsContent>
          <TabsContent value="archive">
            <MessagesArchive />
          </TabsContent>
        </Tabs>
      </section>
    </div>
  );
};
